import { defineStore } from 'pinia';
import {useLanguageStore, useCurrencyStore} from "@/shared/stores";
import {customEvent} from "@/shared/helpers/events";

export const useShopStore = defineStore('shop', {
	state: () => ({
		cart: [],
		showCart: false,
		autoCheckout: false,
	}),
	getters: {
		epsonFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_epson'), answer: languageStore.getString('answer_one_epson'), active: false},{request: languageStore.getString('request_two_epson'), answer: languageStore.getString('answer_two_epson'), active: false},{request: languageStore.getString('request_three_epson'), answer: languageStore.getString('answer_three_epson'), active: false},{request: languageStore.getString('request_four_epson'), answer: languageStore.getString('answer_four_epson'), active: false}]
		},
		printerFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_printer'), answer: languageStore.getString('answer_one_printer'), active: false},{request: languageStore.getString('request_two_printer'), answer: languageStore.getString('answer_two_printer'), active: false},{request: languageStore.getString('request_three_printer'), answer: languageStore.getString('answer_three_printer'), active: false},{request: languageStore.getString('request_four_printer'), answer: languageStore.getString('answer_four_printer'), active: false},{request: languageStore.getString('request_five_printer'), answer: languageStore.getString('answer_five_printer'), active: false},{request: languageStore.getString('request_six_printer'), answer: languageStore.getString('answer_six_printer'), active: false}]
		},
		posFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_pos'), answer: languageStore.getString('answer_one_pos'), active: false},{request: languageStore.getString('request_two_pos'), answer: languageStore.getString('answer_two_pos'), active: false},{request: languageStore.getString('request_four_pos'), answer: languageStore.getString('answer_four_pos'), active: false},{request: languageStore.getString('request_five_pos'), answer: languageStore.getString('answer_five_pos'), active: false}]
		},
		posS700Faqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_pos_s700'), answer: languageStore.getString('answer_one_pos_s700'), active: false},{request: languageStore.getString('request_two_pos_s700'), answer: languageStore.getString('answer_two_pos_s700'), active: false},{request: languageStore.getString('request_three_pos_s700'), answer: languageStore.getString('answer_three_pos_s700'), active: false},{request: languageStore.getString('request_four_pos_s700'), answer: languageStore.getString('answer_four_pos_s700'), active: false},{request: languageStore.getString('request_five_pos_s700'), answer: languageStore.getString('answer_five_pos_s700'), active: false}]
		},
		ttpFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_ttp'), answer: languageStore.getString('answer_one_ttp'), active: false},{request: languageStore.getString('request_two_ttp'), answer: languageStore.getString('answer_two_ttp'), active: false},{request: languageStore.getString('request_three_ttp'), answer: languageStore.getString('answer_three_ttp'), active: false},{request: languageStore.getString('request_four_ttp'), answer: languageStore.getString('answer_four_ttp'), active: false}]
		},
		posWisePadFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_pos_wise_pad'), answer: languageStore.getString('answer_one_pos_wise_pad'), active: false},{request: languageStore.getString('request_two_pos_wise_pad'), answer: languageStore.getString('answer_two_pos_wise_pad'), active: false},{request: languageStore.getString('request_three_pos_wise_pad'), answer: languageStore.getString('answer_three_pos_wise_pad'), active: false},{request: languageStore.getString('request_four_pos_wise_pad'), answer: languageStore.getString('answer_four_pos_wise_pad'), active: false},{request: languageStore.getString('request_five_pos_wise_pad'), answer: languageStore.getString('answer_five_pos_wise_pad'), active: false}]
		},
		tabletD3Faqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_tablet_d3'), answer: languageStore.getString('answer_one_tablet_d3'), active: false},{request: languageStore.getString('request_two_tablet_d3'), answer: languageStore.getString('answer_two_tablet_d3'), active: false},{request: languageStore.getString('request_three_tablet_d3'), answer: languageStore.getString('answer_three_tablet_d3'), active: false},{request: languageStore.getString('request_four_tablet_d3'), answer: languageStore.getString('answer_four_tablet_d3'), active: false},{request: languageStore.getString('request_five_tablet_d3'), answer: languageStore.getString('answer_five_tablet_d3'), active: false},{request: languageStore.getString('request_six_tablet_d3'), answer: languageStore.getString('answer_six_tablet_d3'), active: false}]
		},
		tabletHonorFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_tablet_honor'), answer: languageStore.getString('answer_one_tablet_honor'), active: false},{request: languageStore.getString('request_two_tablet_honor'), answer: languageStore.getString('answer_two_tablet_honor'), active: false},{request: languageStore.getString('request_three_tablet_honor'), answer: languageStore.getString('answer_three_tablet_honor'), active: false},{request: languageStore.getString('request_four_tablet_honor'), answer: languageStore.getString('answer_four_tablet_honor'), active: false},{request: languageStore.getString('request_five_tablet_honor'), answer: languageStore.getString('answer_five_tablet_honor'), active: false}]
		},
		bundleFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_bundle_faq_1'), answer: languageStore.getString('answer_bundle_faq_1'), active: false},{request: languageStore.getString('request_bundle_faq_2'), answer: languageStore.getString('answer_bundle_faq_2'), active: false},{request: languageStore.getString('request_bundle_faq_3'), answer: languageStore.getString('answer_bundle_faq_3'), active: false},{request: languageStore.getString('request_bundle_faq_4'), answer: languageStore.getString('answer_bundle_faq_4'), active: false}]
		},
		V3Faqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_v3'), answer: languageStore.getString('answer_one_v3'), active: false},{request: languageStore.getString('request_two_v3'), answer: languageStore.getString('answer_two_v3'), active: false},{request: languageStore.getString('request_three_v3'), answer: languageStore.getString('answer_three_v3'), active: false},{request: languageStore.getString('request_four_v3'), answer: languageStore.getString('answer_four_v3'), active: false}]
		},
		V3mixFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_v3_mix'), answer: languageStore.getString('answer_one_v3_mix'), active: false},{request: languageStore.getString('request_two_v3_mix'), answer: languageStore.getString('answer_two_v3_mix'), active: false},{request: languageStore.getString('request_three_v3_mix'), answer: languageStore.getString('answer_three_v3_mix'), active: false},{request: languageStore.getString('request_four_v3_mix'), answer: languageStore.getString('answer_four_v3_mix'), active: false}]
		},
		D3miniFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_d3_mini'), answer: languageStore.getString('answer_one_d3_mini'), active: false},{request: languageStore.getString('request_two_d3_mini'), answer: languageStore.getString('answer_two_d3_mini'), active: false},{request: languageStore.getString('request_three_d3_mini'), answer: languageStore.getString('answer_three_d3_mini'), active: false},{request: languageStore.getString('request_four_d3_mini'), answer: languageStore.getString('answer_four_d3_mini'), active: false}]
		},
		D3familyFaqs: state => {
			const languageStore = useLanguageStore();
			return [{request: languageStore.getString('request_one_d3_family'), answer: languageStore.getString('answer_one_d3_family'), active: false},{request: languageStore.getString('request_two_d3_family'), answer: languageStore.getString('answer_two_d3_family'), active: false},{request: languageStore.getString('request_three_d3_family'), answer: languageStore.getString('answer_three_d3_family'), active: false},{request: languageStore.getString('request_four_d3_family'), answer: languageStore.getString('answer_four_d3_family'), active: false}]
		},
		shopItems: state => {
			const languageStore = useLanguageStore();
			return [{
				id: 'v3',
				categoryId: "news",
				title: languageStore.getString('title_v3'),
				subtitle: languageStore.getString('subtitle_v3'),
				description: languageStore.getString('description_v3'),
				imagemin: "https://img.qromo.io/img/V3.webp",
				image: "https://img.qromo.io/img/V3.jpg",
				slides: ["V3", "V3-1", "V3-2", "V3-3", "V3-4", "V3-5"],
				reviews: [{rating: 5}],
				faqs: state.V3Faqs,
				chips: [
					{icon: 'https://img.qromo.io/img/icon-wifi-4.svg', label: languageStore.getString('chip_sim_5g')},
					{icon: 'https://img.qromo.io/img/Icons-stampante-shop.svg', label: languageStore.getString('chip_printer')},
					{icon: 'https://img.qromo.io/img/Icons-pos-shop.svg', label: languageStore.getString('chip_pos')},
				],
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_v3')
					},
					wifi: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_v3')
					},
					sim: {
						title: languageStore.getString('sim_slots'),
						details: languageStore.getString('sim_info_v3')
					},
					connectivity: {
						title: languageStore.getString('nfc'),
						details: languageStore.getString('nfc_info_v3')
					},
					bluetooth: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_v3')
					},
					operatingSystem: {
						title: languageStore.getString('camera'),
						details: languageStore.getString('camera_info_v3')
					},
					processor: {
						title: languageStore.getString('accessories'),
						details: languageStore.getString('accessories_info_v3')
					},
					memory: {
						title: languageStore.getString('cellular'),
						details: languageStore.getString('cellular_info_v3')
					},
					printer: {
						title: languageStore.getString('printer'),
						details: languageStore.getString('printer_info_v3')
					},
					battery: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_v3')
					},
				},
			},{
				id: 'v3mix',
				categoryId: "news",
				title: languageStore.getString('title_v3_mix'),
				subtitle: languageStore.getString('subtitle_v3_mix'),
				description: languageStore.getString('description_v3_mix'),
				imagemin: "https://img.qromo.io/img/V3mix.webp",
				image: "https://img.qromo.io/img/V3mix.jpg",
				slides: ["V3mix", "V3mix-1", "V3mix-2", "V3mix-3", "V3mix-4", "V3mix-5"],
				reviews: [{rating: 5}],
				faqs: state.V3mixFaqs,
				chips: [
					{icon: 'https://img.qromo.io/img/icon-wifi-4.svg', label: languageStore.getString('chip_sim_5g')},
					{icon: 'https://img.qromo.io/img/Icons-stampante-shop.svg', label: languageStore.getString('chip_printer')},
					{icon: 'https://img.qromo.io/img/Icons-pos-shop.svg', label: languageStore.getString('chip_pos')},
				],
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_pos_s700')
					},
					wifi: {
						title: languageStore.getString('payment_types'),
						details: languageStore.getString('payment_types_info_pos_s700')
					},
					sim: {
						title: languageStore.getString('connectivity'),
						details: languageStore.getString('connectivity_info_pos_s700')
					},
					connectivity: {
						title: languageStore.getString('operating_system'),
						details: languageStore.getString('operating_system_info_pos_s700')
					},
					bluetooth: {
						title: languageStore.getString('memory'),
						details: languageStore.getString('memory_info_pos_s700')
					},
					memory: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_pos_s700')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_pos_s700')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_pos_s700')
					},
				},
			},{
				id: 'd3mini',
				categoryId: "news",
				title: languageStore.getString('title_d3_mini'),
				subtitle: languageStore.getString('subtitle_d3_mini'),
				description: languageStore.getString('description_d3_mini'),
				imagemin: "https://img.qromo.io/img/D3mini.webp",
				image: "https://img.qromo.io/img/D3mini.jpg",
				slides: ["D3mini", "D3mini-1", "D3mini-2", "D3mini-3", "D3mini-4", "D3mini-5"],
				reviews: [{rating: 5}],
				faqs: state.D3miniFaqs,
				chips: [
					{icon: 'https://img.qromo.io/img/Icons-cavo.svg', label: languageStore.getString('chip_one_cable')},
					{icon: 'https://img.qromo.io/img/Icons-stampante-shop.svg', label: languageStore.getString('chip_printer')},
					{icon: 'https://img.qromo.io/img/Icons-pos-shop.svg', label: languageStore.getString('chip_pos')},
				],
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_d3_mini')
					},
					wifi: {
						title: languageStore.getString('printer'),
						details: languageStore.getString('printer_info_d3_mini')
					},
					sim: {
						title: languageStore.getString('nfc'),
						details: languageStore.getString('nfc_info_d3_mini')
					},
					connectivity: {
						title: languageStore.getString('sim_slots'),
						details: languageStore.getString('sim_info_d3_mini')
					},
					bluetooth: {
						title: languageStore.getString('scanner'),
						details: languageStore.getString('scanner_info_d3_mini')
					},
					operatingSystem: {
						title: languageStore.getString('ports'),
						details: languageStore.getString('ports_info_d3_mini')
					},
					processor: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_d3_mini')
					},
					memory: {
						title: languageStore.getString('network'),
						details: languageStore.getString('cellular_info_d3_mini')
					},
					printer: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_d3_mini')
					},
					battery: {
						title: languageStore.getString('memory'),
						details: languageStore.getString('memory_info_d3_mini')
					},
				},
			},{
				id: 'd3family',
				categoryId: "news",
				title: languageStore.getString('title_d3_family'),
				subtitle: languageStore.getString('subtitle_d3_family'),
				description: languageStore.getString('description_d3_family'),
				imagemin: "https://img.qromo.io/img/D3family.webp",
				image: "https://img.qromo.io/img/D3family.jpg",
				slides: ["D3family", "D3family-1", "D3family-2", "D3family-3", "D3family-4", "D3family-5"],
				reviews: [{rating: 5}],
				faqs: state.D3familyFaqs,
				chips: [
					{icon: 'https://img.qromo.io/img/Icons-cavo.svg', label: languageStore.getString('chip_one_cable')},
					{icon: 'https://img.qromo.io/img/Icons-stampante-shop.svg', label: languageStore.getString('chip_printer')},
					{icon: 'https://img.qromo.io/img/Icons-pos-shop.svg', label: languageStore.getString('chip_pos')},
				],
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_d3_family')
					},
					wifi: {
						title: languageStore.getString('printer'),
						details: languageStore.getString('printer_info_d3_family')
					},
					sim: {
						title: languageStore.getString('nfc'),
						details: languageStore.getString('nfc_info_d3_family')
					},
					connectivity: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_d3_family')
					},
					bluetooth: {
						title: languageStore.getString('ethernet'),
						details: languageStore.getString('ethernet_info_d3_family')
					},
					operatingSystem: {
						title: languageStore.getString('ports'),
						details: languageStore.getString('ports_info_d3_family')
					},
					processor: {
						title: languageStore.getString('memory'),
						details: languageStore.getString('memory_info_d3_family')
					},
					memory: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_d3_family')
					},
					printer: {
						title: languageStore.getString('power_adapter'),
						details: languageStore.getString('power_adapter_info_d3_family')
					},
					battery: {
						title: languageStore.getString('accessories'),
						details: languageStore.getString('accessories_info_d3_family')
					},
				},
			},{
				id: 'qromotabletd3',
				categoryId: "tablet",
				title: languageStore.getString('qromo_tablet_d3'),
				subtitle: languageStore.getString('qromo_tablet_d3_subtitle'),
				description: languageStore.getString('qromo_tablet_d3_description'),
				imagemin: "https://img.qromo.io/img/Qromo-tablet-d3.webp",
				image: "https://img.qromo.io/img/Qromo-tablet-d3.jpg",
				slides: ["Qromo-tablet-d3", "tablet-1-d3", "tablet-2-d3", "tablet-3-d3", "tablet-4-d3"],
				reviews: [{rating: 5}],
				faqs: state.tabletD3Faqs,
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_tablet_d3')
					},
					wifi: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_tablet_d3')
					},
					sim: {
						title: languageStore.getString('sim_slots'),
						details: languageStore.getString('sim_info_tablet_d3')
					},
					connectivity: {
						title: languageStore.getString('connectivity'),
						details: languageStore.getString('external_doors_info_tablet_d3')
					},
					bluetooth: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_tablet_d3')
					},
					operatingSystem: {
						title: languageStore.getString('external_memory_card'),
						details: languageStore.getString('external_memory_card_info_tablet_d3')
					},
					processor: {
						title: languageStore.getString('accessories'),
						details: languageStore.getString('accessories_tablet_d3')
					},
					memory: {
						title: languageStore.getString('operating_system'),
						details: languageStore.getString('operating_system_info_tablet_d3')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_tablet_d3')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_tablet_d3')
					},
				},
			},{
				id: 'qromotablethonor',
				categoryId: "tablet",
				title: languageStore.getString('qromo_tablet_honor'),
				subtitle: languageStore.getString('qromo_tablet_honor_subtitle'),
				description: languageStore.getString('qromo_tablet_honor_description'),
				imagemin: "https://img.qromo.io/img/Qromo-tablet-honor-new.webp",
				image: "https://img.qromo.io/img/Qromo-tablet-honor-new.jpg",
				slides: ["Qromo-tablet-honor-new", "tablet-1-honor", "tablet-2-honor", "tablet-3-honor", "tablet-4-honor"],
				reviews: [{rating: 4.7}],
				faqs: state.tabletHonorFaqs,
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_tablet_honor')
					},
					bluetooth: {
						title: languageStore.getString('certifications_tablet_honor'),
						details: languageStore.getString('certifications_tablet_info_honor')
					},
					operatingSystem: {
						title: languageStore.getString('memory'),
						details: languageStore.getString('memori_info_tablet_honor')
					},
					processor: {
						title: languageStore.getString('gpu_tablet_honor'),
						details: languageStore.getString('gpu_tablet_info_honor')
					},
					memory: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_tablet_honor')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_tablet_honor')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_tablet_honor')
					},
				},
			},{
				id: 'qromotaptopay',
				categoryId: "POS",
				title: languageStore.getString('qromo_t2p'),
				subtitle: languageStore.getString('qromo_t2p_subtitle'),
				description: languageStore.getString('qromo_t2p_description'),
				imagemin: "https://img.qromo.io/img/TTP-iphone-phone.webp",
				image: "https://img.qromo.io/img/TTP-iphone-phone.jpg",
				slides: ["TTP-iphone-phone", "TTP-iphone-hands", "TTP-iphone-lifestyle", "TTP-android-phone", "TTP-android-hands", "TTP-android-lifestyle"],
				reviews: [{rating: 5}],
				faqs: state.ttpFaqs,
				hideAddToCartBtn: true,
				downloadLinks: {
					ios: "https://apps.apple.com/it/app/qromo-gestionale/id6670559241",
					android: "https://play.google.com/store/apps/details?id=it.cromosrl.qromo"
				}
			},{
				id: 'qromopos700',
				categoryId: "POS",
				title: languageStore.getString('qromo_pos_s700'),
				subtitle: languageStore.getString('qromo_pos_s700_subtitle'),
				description: languageStore.getString('qromo_pos_s700_description'),
				imagemin: "https://img.qromo.io/img/Qromo-pos-s700.webp",
				image: "https://img.qromo.io/img/Qromo-pos-s700.jpg",
				slides: ["Qromo-pos-s700", "pos-1-s700", "pos-2-s700", "pos-3-s700", "pos-4-s700", "pos-5-s700"],
				reviews: [{rating: 4.9}],
				faqs: state.posS700Faqs,
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_pos_s700')
					},
					wifi: {
						title: languageStore.getString('payment_types'),
						details: languageStore.getString('payment_types_info_pos_s700')
					},
					sim: {
						title: languageStore.getString('connectivity'),
						details: languageStore.getString('connectivity_info_pos_s700')
					},
					connectivity: {
						title: languageStore.getString('operating_system'),
						details: languageStore.getString('operating_system_info_pos_s700')
					},
					bluetooth: {
						title: languageStore.getString('memory'),
						details: languageStore.getString('memory_info_pos_s700')
					},
					memory: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_pos_s700')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_pos_s700')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_pos_s700')
					},
				},
			},{
				id: 'qromopos',
				categoryId: "POS",
				title: languageStore.getString('qromo_pos'),
				subtitle: languageStore.getString('qromo_pos_subtitle'),
				description: languageStore.getString('qromo_pos_description'),
				imagemin: "https://img.qromo.io/img/Qromo-pos.webp",
				image: "https://img.qromo.io/img/Qromo-pos.jpg",
				slides: ["Qromo-pos", "pos-1", "pos-2", "pos-3", "pos-4", "pos-5"],
				reviews: [{rating: 4}],
				faqs: state.posFaqs,
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_sun')
					},
					wifi: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_pos')
					},
					sim: {
						title: languageStore.getString('sim_slots'),
						details: languageStore.getString('sim_info_sun')
					},
					connectivity: {
						title: languageStore.getString('connectivity'),
						details: languageStore.getString('connectivity_info_sun')
					},
					bluetooth: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_sun')
					},
					operatingSystem: {
						title: languageStore.getString('data_protection'),
						details: languageStore.getString('data_protection_info_pos')
					},
					processor: {
						title: languageStore.getString('certification'),
						details: languageStore.getString('certification_info_pos')
					},
					memory: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_pos')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_pos')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_pos')
					},
				},
			},{
				id: 'qromobundle',
				categoryId: "news",
				title: languageStore.getString('qromo_bundle'),
				subtitle: languageStore.getString('qromo_bundle_subtitle'),
				description: languageStore.getString('qromo_bundle_description'),
				imagemin: "https://img.qromo.io/img/promo-gennaio-new-1-mod.webp",
				image: "https://img.qromo.io/img/promo-gennaio-new-1-mod.jpg",
				slides: ["promo-gennaio-new-1-mod", "tablet-1-d3", "tablet-2-d3", "pos-1", "pos-2", "epson-1", "epson-2"],
				reviews: [{rating: 4}],
				faqs: state.bundleFaqs,
				techSpecSections: [
					{
						title: languageStore.getString('qromo_pos'),
						specs: {
							screen: {
								title: languageStore.getString('screen'),
								details: languageStore.getString('screen_info_sun')
							},
							wifi: {
								title: languageStore.getString('wifi'),
								details: languageStore.getString('wifi_info_pos')
							},
							sim: {
								title: languageStore.getString('sim_slots'),
								details: languageStore.getString('sim_info_sun')
							},
							connectivity: {
								title: languageStore.getString('connectivity'),
								details: languageStore.getString('connectivity_info_sun')
							},
							bluetooth: {
								title: languageStore.getString('bluetooth'),
								details: languageStore.getString('bluetooth_info_sun')
							},
							operatingSystem: {
								title: languageStore.getString('data_protection'),
								details: languageStore.getString('data_protection_info_pos')
							},
							processor: {
								title: languageStore.getString('certification'),
								details: languageStore.getString('certification_info_pos')
							},
							memory: {
								title: languageStore.getString('battery'),
								details: languageStore.getString('battery_info_pos')
							},
							printer: {
								title: languageStore.getString('dimensions'),
								details: languageStore.getString('dimensions_info_pos')
							},
							battery: {
								title: languageStore.getString('weight'),
								details: languageStore.getString('weight_info_pos')
							},
						}
					},
					{
						title: languageStore.getString('epson_printer'),
						specs: {
							operatingSystem: {
								title: languageStore.getString('tax_specifications'),
								details: languageStore.getString('tax_specifications_info_epson')
							},
							memory: {
								title: languageStore.getString('printer'),
								details: languageStore.getString('printer_info_epson')
							},
							wifi: {
								title: languageStore.getString('paper'),
								details: languageStore.getString('paper_info_epson')
							},
							sim: {
								title: languageStore.getString('power_supply'),
								details: languageStore.getString('power_supply_info_epson')
							},
							connectivity: {
								title: languageStore.getString('interfaces'),
								details: languageStore.getString('interfaces_info_epson')
							},
							bluetooth: {
								title: languageStore.getString('dimensions'),
								details: languageStore.getString('dimensions_info_epson')
							},
							printer: {
								title: languageStore.getString('weight'),
								details: languageStore.getString('weight_info_epson')
							},
							processor: {
								title: languageStore.getString('buffer_dati'),
								details: languageStore.getString('buffer_dati_info_epson')
							},
						}
					},
					{
						title: languageStore.getString('qromo_tablet_d3'),
						specs: {
							screen: {
								title: languageStore.getString('screen'),
								details: languageStore.getString('screen_info_tablet_d3')
							},
							wifi: {
								title: languageStore.getString('wifi'),
								details: languageStore.getString('wifi_info_tablet_d3')
							},
							sim: {
								title: languageStore.getString('sim_slots'),
								details: languageStore.getString('sim_info_tablet_d3')
							},
							connectivity: {
								title: languageStore.getString('connectivity'),
								details: languageStore.getString('external_doors_info_tablet_d3')
							},
							bluetooth: {
								title: languageStore.getString('bluetooth'),
								details: languageStore.getString('bluetooth_info_tablet_d3')
							},
							operatingSystem: {
								title: languageStore.getString('external_memory_card'),
								details: languageStore.getString('external_memory_card_info_tablet_d3')
							},
							processor: {
								title: languageStore.getString('accessories'),
								details: languageStore.getString('accessories_tablet_d3')
							},
							memory: {
								title: languageStore.getString('operating_system'),
								details: languageStore.getString('operating_system_info_tablet_d3')
							},
							printer: {
								title: languageStore.getString('dimensions'),
								details: languageStore.getString('dimensions_info_tablet_d3')
							},
							battery: {
								title: languageStore.getString('weight'),
								details: languageStore.getString('weight_info_tablet_d3')
							},
						}
					}
				],
			},{
				id: 'qromoposwisepad',
				categoryId: "POS",
				title: languageStore.getString('qromo_pos_wise_pad'),
				subtitle: languageStore.getString('qromo_pos_wise_pad_subtitle'),
				description: languageStore.getString('qromo_pos_wise_pad_description'),
				imagemin: "https://img.qromo.io/img/Qromo-pos-wise-pad.webp",
				image: "https://img.qromo.io/img/Qromo-pos-wise-pad.jpg",
				slides: ["Qromo-pos-wise-pad", "pos-1-wise-pad", "pos-2-wise-pad", "pos-3-wise-pad", "pos-4-wise-pad", "pos-5-wise-pad"],
				reviews: [{rating: 4.5}],
				faqs: state.posWisePadFaqs,
				techSpec: {
					screen: {
						title: languageStore.getString('screen'),
						details: languageStore.getString('screen_info_pos_wise_pad')
					},
					wifi: {
						title: languageStore.getString('payment_types'),
						details: languageStore.getString('payment_types_info_pos_wise_pad')
					},
					sim: {
						title: languageStore.getString('safety'),
						details: languageStore.getString('safety_info_pos_wise_pad')
					},
					connectivity: {
						title: languageStore.getString('connectivity'),
						details: languageStore.getString('connectivity_info_pos_wise_pad')
					},
					memory: {
						title: languageStore.getString('battery'),
						details: languageStore.getString('battery_info_pos_wise_pad')
					},
					printer: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_pos_wise_pad')
					},
					battery: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_pos_wise_pad')
					},
				},
			},{
				id: 'epsonprinter',
				categoryId: "printer",
				title: languageStore.getString('epson_printer'),
				subtitle: languageStore.getString('epson_printer_subtitle'),
				description: languageStore.getString('epson_printer_description'),
				imagemin: "https://img.qromo.io/img/Epson-printer.webp",
				image: "https://img.qromo.io/img/Epson-printer.jpg",
				slides: ["Epson-printer", "epson-1", "epson-2", "epson-3", "epson-4", "epson-5"],
				reviews: [{rating: 4}],
				faqs: state.epsonFaqs,
				techSpec: {
					operatingSystem: {
						title: languageStore.getString('tax_specifications'),
						details: languageStore.getString('tax_specifications_info_epson')
					},
					memory: {
						title: languageStore.getString('printer'),
						details: languageStore.getString('printer_info_epson')
					},
					wifi: {
						title: languageStore.getString('paper'),
						details: languageStore.getString('paper_info_epson')
					},
					sim: {
						title: languageStore.getString('power_supply'),
						details: languageStore.getString('power_supply_info_epson')
					},
					connectivity: {
						title: languageStore.getString('interfaces'),
						details: languageStore.getString('interfaces_info_epson')
					},
					bluetooth: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_epson')
					},
					printer: {
						title: languageStore.getString('weight'),
						details: languageStore.getString('weight_info_epson')
					},
					processor: {
						title: languageStore.getString('buffer_dati'),
						details: languageStore.getString('buffer_dati_info_epson')
					},
				},
			},{
				id: 'qromoprinter',
				categoryId: "printer",
				title: languageStore.getString('qromo_printer'),
				subtitle: languageStore.getString('qromo_printer_subtitle'),
				description: languageStore.getString('qromo_printer_description'),
				imagemin: "https://img.qromo.io/img/Qromo-printer.webp",
				image: "https://img.qromo.io/img/Qromo-printer.jpg",
				slides: ["Qromo-printer", "printer-1", "printer-2", "printer-3", "printer-4", "printer-5"],
				reviews: [{rating: 4.8}],
				faqs: state.printerFaqs,
				techSpec: {
					operatingSystem: {
						title: languageStore.getString('printer'),
						details: languageStore.getString('printer_info_printer')
					},
					processor: {
						title: languageStore.getString('cutter'),
						details: languageStore.getString('cutter_info_printer')
					},
					memory: {
						title: languageStore.getString('speaker'),
						details: languageStore.getString('speaker_paper_info_printer')
					},
					screen: {
						title: languageStore.getString('printing_paper'),
						details: languageStore.getString('printing_paper_info_printer')
					},
					wifi: {
						title: languageStore.getString('wifi'),
						details: languageStore.getString('wifi_info_printer')
					},
					sim: {
						title: languageStore.getString('indicator_lights'),
						details: languageStore.getString('indicator_lights_info_printer')
					},
					connectivity: {
						title: languageStore.getString('sensor'),
						details: languageStore.getString('sensor_info_printer')
					},
					bluetooth: {
						title: languageStore.getString('bluetooth'),
						details: languageStore.getString('bluetooth_info_printer')
					},
					printer: {
						title: languageStore.getString('ethernet'),
						details: languageStore.getString('ethernet_info_printer')
					},
					battery: {
						title: languageStore.getString('dimensions'),
						details: languageStore.getString('dimensions_info_printer')
					},
				},
			}];
		},
	},
	actions: {
		currencyShopItem(itemId) {
			return itemId ? useCurrencyStore()?.currCurrency?.prices?.[itemId] : null;
		},
		currencyItemPrice(item, priceFull = false) {
			let priceFullPart = priceFull ? '_full' : '';
			return this.currencyShopItem(item?.id)?.['amount'+priceFullPart] || 0;
		},
		getItem(item) {
			let index = this.cart.findIndex(cartItem => cartItem.id === item.id);
			if(index !== -1) {
				return this.cart[index];
			} else {
				return null;
			}
		},
		getItemQuantity(item) {
			let itemFound = this.getItem(item);
			return itemFound ? itemFound.quantity : 0;
		},
		getTotalItemQuantity() {
			return this.cart.reduce((acc, curr) => {
				return acc + curr.quantity;
			}, 0);
		},
		getSubtotal() {
			return this.cart.reduce((acc, curr) => {
				let item = this.getItemById(curr.id);
				let finalPrice = this.currencyItemPrice(item);
				return acc + (curr.quantity*finalPrice);
			}, 0);
		},
		addItemToCart(card, quantity = 1) {
			let index = this.cart.findIndex(cartItem => cartItem.id === card.id);
			if(index !== -1) {
				this.cart[index].quantity += quantity;
			} else {
				this.cart.push({
					id: card.id,
					quantity
				});
			}

			customEvent('add_to_cart', {
				currency: useCurrencyStore()?.currCurrency?.code || 'EUR',
				value: this.currencyItemPrice(card) * quantity,
				items: [{
					item_id: card.id,
					item_name: card.title,
					item_category: card.categoryId,
					price: this.currencyItemPrice(card),
					quantity: quantity
				}]
			});
		},
		removeItemFromCart(item, quantity = 1) {
			let index = this.cart.findIndex(cartItem => cartItem.id === item.id);
			if(index !== -1) {
				this.cart[index].quantity -= quantity;
				if(this.cart[index].quantity <= 0) {
					this.cart.splice(index, 1)
				}
			}

			customEvent('remove_from_cart', {
				currency: useCurrencyStore()?.currCurrency?.code || 'EUR',
				value: this.currencyItemPrice(item) * quantity,
				items: [{
					item_id: item.id,
					item_name: item.title,
					item_category: item.categoryId,
					price: this.currencyItemPrice(item),
					quantity: quantity
				}]
			});
		},
		changeItemQuantity(item, quantity) {
			quantity = Math.round(quantity);
			quantity = quantity < 0 ? 0 : quantity;
			let index = this.cart.findIndex(cartItem => cartItem.id === item.id);
			let oldQuantity = index !== -1 ? this.cart[index].quantity : 0;
			let quantityDiff = quantity - oldQuantity;

			if(index !== -1) {
				this.cart[index].quantity = quantity;
			} else if(quantity > 0) {
				this.cart.push({
					id: item.id,
					quantity
				});
			}

			if(quantityDiff !== 0) {
				const eventName = quantityDiff > 0 ? 'add_to_cart' : 'remove_from_cart';
				customEvent(eventName, {
					currency: useCurrencyStore()?.currCurrency?.code || 'EUR',
					value: this.currencyItemPrice(item) * Math.abs(quantityDiff),
					items: [{
						item_id: item.id,
						item_name: item.title,
						item_category: item.categoryId,
						price: this.currencyItemPrice(item),
						quantity: Math.abs(quantityDiff)
					}]
				});
			}
		},
		getItemById(id) {
			return this.shopItems.find(cartItem => cartItem.id === id);
		}
	}
});
